import { TransProps, useTranslation } from 'react-i18next';
import * as Yup from 'yup';

import { postalCodeRegexp, taxIdRegexp } from '../../../constants';
import { BillingAddressFormData } from '../../../interfaces';

import { UseBillingAddressForm } from './billingAddressForm.types';

export const useBillingAddressFormValidation: () => UseBillingAddressForm = (): UseBillingAddressForm => {
  const { t }: TransProps<never> = useTranslation();

  const baseSchema: Yup.SchemaOf<BillingAddressFormData>= Yup.object().shape({
    firstName: Yup.string()
      .max(64, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    lastName: Yup.string()
      .max(128, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    street: Yup.string()
      .max(128, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    houseNumber: Yup.string()
      .max(8, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    apartmentNumber: Yup.string()
      .max(8, t('onarte.common.validations.maxLength'))
      .optional()
      .nullable(),
    postalCode: Yup.string()
      .required(t('onarte.common.requiredField'))
      .matches(postalCodeRegexp, t('onarte.common.validations.postalCode')),
    city: Yup.string()
      .max(128, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    country: Yup.string()
      .max(64, t('onarte.common.validations.maxLength'))
      .required(t('onarte.common.requiredField')),
    companyName: Yup.string()
      .max(128, t('onarte.common.validations.maxLength'))
      .optional(),
    taxId: Yup.string()
      .max(16, t('onarte.common.validations.maxLength'))
      .optional(),
  });

  const schemaForCompany: Yup.SchemaOf<BillingAddressFormData> = baseSchema.shape({
    companyName: Yup.string()
      .required(t('onarte.common.requiredField')),
    taxId: Yup.string()
      .required(t('onarte.common.requiredField'))
      .matches(taxIdRegexp, t('onarte.common.validations.taxId')),
  });

  return { baseSchema, schemaForCompany };
};
